import React, { useState, useRef } from "react";
import axios from "axios";
import { FileText, Mail, Building2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DOC_NAMES = { contract: "Dogovor-oferta", invoice: "Schet", act: "Akt" };

const downloadPdf = async (taskId, docType) => {
  const res = await axios.get(`${API}/b2b/tasks/${taskId}/documents/${docType}.pdf`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${DOC_NAMES[docType]}-${taskId.slice(0, 8)}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const B2BDocumentsBlock = ({ task, showToast }) => {
  const [busy, setBusy] = useState(false);
  const inFlight = useRef(false);
  if (!task?.is_b2b || task.status !== "confirmed") return null;

  // A2: повторные клики во время запроса игнорируются
  const once = async (fn) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    try {
      await fn();
    } finally {
      inFlight.current = false;
      setBusy(false);
    }
  };

  const generate = () => once(async () => {
    try {
      for (const t of ["contract", "invoice", "act"]) await downloadPdf(task.id, t);
      showToast("Пакет документов сформирован: договор-оферта, счёт и акт скачаны", "success");
    } catch (e) {
      showToast(e.response?.data?.detail || "Не удалось сформировать документы", "error");
    }
  });

  const sendEmail = () => once(async () => {
    try {
      const r = await axios.post(`${API}/b2b/tasks/${task.id}/documents/send`);
      showToast(r.data?.message || "Документы отправлены", "success");
    } catch (e) {
      showToast(e.response?.data?.detail || "Не удалось отправить документы", "error");
    }
  });

  return (
    <div data-testid="b2b-documents-block" className="mt-3 p-3 rounded-lg" style={{ background: "#F0F9FF", border: "1px solid #7DD3FC" }}>
      <div className="flex items-center gap-2 text-sm font-semibold mb-2" style={{ color: "#0C4A6E" }}>
        <Building2 size={15} /> Закрывающие документы по заданию от организации
      </div>
      <p className="text-xs mb-3" style={{ color: "#0C4A6E" }}>
        Договор-оферта, счёт на оплату и акт выполненных работ формируются по данным задания и профилей сторон. Документы подлежат подписанию сторонами;
        оплата — напрямую исполнителю (реквизиты исполнитель передаёт в чате), чек выдаёт исполнитель.
      </p>
      <div className="flex flex-wrap gap-2">
        <button data-testid="b2b-generate-docs-btn" onClick={generate} disabled={busy}
          className="reversia-btn reversia-btn-md flex items-center gap-1.5 disabled:opacity-60" style={{ background: "#0369A1", color: "#fff" }}>
          <FileText size={14} /> Сформировать пакет документов
        </button>
        <button data-testid="b2b-send-docs-btn" onClick={sendEmail} disabled={busy}
          className="reversia-btn reversia-btn-quiet reversia-btn-md flex items-center gap-1.5 disabled:opacity-60">
          <Mail size={14} /> Отправить на email
        </button>
      </div>
    </div>
  );
};
